namespace TabAurous.OMS {
    export interface FixedRateMasterRow {
        CostId?: number;
        ProductId?: number;
        ProductCode?: string;
        AttributeId?: number;
        FromWt?: number;
        ToWt?: number;
        FromDate?: string;
        ToDate?: string;
        PurchaseRate?: number;
        SalesRate?: number;
        Attribute?: string;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        ProductTypeCode?: string;
        CategoryCode?: string;
        SubCategoryCode?: string;
        ItemTypeId?: number;
    }

    export namespace FixedRateMasterRow {
        export const idProperty = 'CostId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'OMS.FixedRateMaster';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CostId = "CostId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            FromWt = "FromWt",
            ToWt = "ToWt",
            FromDate = "FromDate",
            ToDate = "ToDate",
            PurchaseRate = "PurchaseRate",
            SalesRate = "SalesRate",
            Attribute = "Attribute",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            ProductTypeCode = "ProductTypeCode",
            CategoryCode = "CategoryCode",
            SubCategoryCode = "SubCategoryCode",
            ItemTypeId = "ItemTypeId"
        }
    }
}
